import React, { useState } from 'react';
import { ExperienceEntry } from '../../types';
import { useApp } from '../../context/AppContext';
import { linkifyProductos } from '../../lib/linkify';
import { etiqueta, periodo } from '../../data/etiquetas';
import './TimelineItem.css';

interface Props {
  entry: ExperienceEntry;
  index: number;
}

const TimelineItem: React.FC<Props> = ({ entry, index }) => {
  const { t, lang } = useApp();
  const [expanded, setExpanded] = useState(index < 2);

  return (
    <div className={`timeline-item ${expanded ? 'timeline-item--expanded' : ''}`}>
      <div className="timeline-item__dot" />
      <div className="timeline-item__card">
        <div
          className="timeline-item__header"
          onClick={() => setExpanded(e => !e)}
          role="button"
          aria-expanded={expanded}
          tabIndex={0}
          onKeyDown={e => e.key === 'Enter' && setExpanded(v => !v)}
        >
          <div className="timeline-item__meta">
            <span className="timeline-item__period">{periodo(entry.period, lang)}</span>
            <span className="timeline-item__sector">{t(entry.sector)}</span>
          </div>
          <h3 className="timeline-item__role">{t(entry.role)}</h3>
          <p className="timeline-item__company">{linkifyProductos(entry.company)}</p>
          <span className="timeline-item__toggle">{expanded ? '−' : '+'}</span>
        </div>

        {expanded && (
          <div className="timeline-item__body">
            <p className="timeline-item__summary">{linkifyProductos(t(entry.summary))}</p>
            {entry.responsibilities && entry.responsibilities.length > 0 && (
              <ul className="timeline-item__responsibilities">
                {entry.responsibilities.map((r, i) => (
                  <li key={i}>{linkifyProductos(t(r))}</li>
                ))}
              </ul>
            )}
            <div className="timeline-item__tags">
              {entry.tags.map(tag => (
                <span key={tag} className="timeline-item__tag">{etiqueta(tag, lang)}</span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimelineItem;
